import { array, object } from "superstruct";

import { RewardsProductSchema } from "./RewardsFreeProductSchemas/RewardsFreeProductSchema";
import { RewardsProductVariantSchema } from "./RewardsFreeProductSchemas/RewardsFreeProductVariantSchema";
import { RewardsIconSizeSchema } from "./RewardsIconSchema";

export const RewardsMetadataSchema = object({
    icons: array(RewardsIconSizeSchema),
    products: array(RewardsProductSchema),
    variants: array(RewardsProductVariantSchema),
});
